import { useTranslation } from 'react-i18next';
import {
  FormContainerWithHeader,
  PaperLayout,
} from '../../../../../presentation';

import './policy.overview.endorsement-list.scss';

export const EndorsementListFormSection = () => {
  const { t } = useTranslation();

  return (
    <FormContainerWithHeader
      title={t(
        'entities.policy.detail.content.sections.overview.endorsementList',
        'Endorsement list'
      )}
    >
      <PaperLayout className="endorsement-list-form-section-paper-layout">
        <p>To be Implemented</p>
      </PaperLayout>
    </FormContainerWithHeader>
  );
};
